import config from "@/config/"
import axios from "axios"

export default ({
	query = null,
	variables = null,
	url = config.ENDPOINT,
	method = "POST",
	locale = window.localStorage["covergo-locale"] || "en-US",
	headers = {}
}) => {
	if (!query) console.error("GQL: there was no query to send")

	const token = window.TK || null
	if (token) headers["Authorization"] = `Bearer ${token}`

	console.group("--------------- API REQUEST ---------------")
	console.log(`Language: ${locale}`)
	console.log("Query: \n", query)
	console.log("Variables:", variables)
	console.groupEnd()

	return new Promise((resolve, reject) => {
		axios({
			baseURL: url,
			timeout: 60000,
			method,
			data: {
				query,
				variables
			},
			headers: {
				...headers,
				"Content-type": "application/json",
				"Accept-Language": locale
			},
			validateStatus: function(status) {
				return status >= 200 && status < 404 // everything between 200 and 404 is ok
			}
		})
			.then(res => {
				console.group("--------------- API RESPONSE ---------------")
				console.dir(res)
				console.groupEnd()
				resolve(res.data)
			})
			// TODO: this catch can be removed after we refactor api calls and fully implement responseInterceptor
			.catch(error => {
				console.error("GQL: There was an error in response", error)
				reject(error)
			})
	})
}
